import { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, useMap } from "react-leaflet";
import L from "leaflet";
import { OSM_TILE_URL, OSM_ATTR } from "@/lib/mapTiles";

function Fit({ pts }) {
  const map = useMap();
  useEffect(() => {
    if (!pts.length) return;
    try {
      const b = L.latLngBounds(pts.map((p) => [p.lat, p.lng]));
      map.fitBounds(b.pad(0.4), { maxZoom: 15 });
    } catch { /* ignore */ }
  }, [pts, map]);
  return null;
}

export default function ImportMiniMap({ points }) {
  const pts = (points || []).filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  const center = pts.length ? [pts[0].lat, pts[0].lng] : [52.1, 19.4];
  return (
    <div className="rounded border border-slate-700 overflow-hidden" style={{ height: 200 }} data-testid="import-minimap">
      <MapContainer center={center} zoom={6} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false} attributionControl={false}>
        <TileLayer url={OSM_TILE_URL} attribution={OSM_ATTR} />
        {pts.map((p, i) => (
          <CircleMarker key={i} center={[p.lat, p.lng]} radius={5}
            pathOptions={{ color: "#06b6d4", fillColor: "#06b6d4", fillOpacity: 0.85, weight: 1 }} />
        ))}
        <Fit pts={pts} />
      </MapContainer>
    </div>
  );
}
